import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import {
  function_ABM_ZON_Plantas_ModificarLogo
} from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";
import { function_base64ToHex } from "../../funciones/Varios";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { function_ABM_IMP_PuntosFiscales_Generar_JSON, function_ABM_IMP_PuntosFiscales_Insertar, function_ABM_IMP_PuntosFiscales_Leer, function_ABM_IMP_PuntosFiscales_Modificar } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_PuntosFiscales";

const ABM_IMP_PuntosFiscales = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [imagenLogoBase64, setImagenLogoBase64] = useState(null);
  const [imagenLogoPreview, setImagenLogoPreview] = useState(null);

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_IMP_PuntosFiscales_Generar_JSON(
        datos.CodigoPuntoFiscal,
        datos.IdTipoMovimiento,
        datos.IdTipo,
        datos.UltimoNumero,
        datos.IdEstado,
        datos.EsElectronico,
        datos.PathCertificado,
        datos.CUIT,
        datos.Terminal,
        datos.Fiscal_RazonSocial,
        datos.Fiscal_Domicilio,
        datos.Fiscal_Telefono,
        datos.Fiscal_Email,
        datos.Fiscal_Web,
        datos.Fiscal_CondicionIVA,
        datos.Fiscal_CUIT,
        datos.Fiscal_IIBB,
        datos.Fiscal_TipoIIBB,
        datos.Fiscal_InicioActividadAFIP,
        datos.Fiscal_InicioActividadIIBB,
        datos.CodigoListaPrecios,
        datos.CodigoUbicacionPredeterminada,
        datos.ImpresoraFiscalTipo,
        datos.ImpresoraFiscalPuerto,
        datos.ImpresoraComandera1,
        datos.ImpresoraComandera2,
        datos.ImpresoraComandera3,
        datos.ImpresoraComanderaTicket,
        datos.ImpresoraStandard,
        datos.ImpresoraFiscalIP,
        datos.ImpresoraComanderaRetiro,
        datos.ColumnasImpresoraComanderaTicket,
        datos.ImpresoraComandera4,
        datos.CAIImprime,
        datos.CAI,
        datos.CAIComprobanteDesde,
        datos.CAIComprobanteHasta,
        datos.CAIFechaVencimiento
      )

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_IMP_PuntosFiscales_Insertar(JSON)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_IMP_PuntosFiscales_Modificar(JSON)

        alert("Se ha modificado el Código: " + datos.CodigoPlanta)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClick_GuardarImagenLogo = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenLogoBase64);

      await function_ABM_ZON_Plantas_ModificarLogo(props.Codigo.Codigo, logoHex);
      alert("Logo guardado correctamente");
    } catch (error) {
      alert("Error al guardar el logo");
      console.error(error);
    }
  };

  const handleImagenLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenLogoPreview(reader.result); // Vista previa
        setImagenLogoBase64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoPuntoFiscal: '',
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            IdTipoMovimiento: 0,
            IdTipo: 0,
            UltimoNumero: 0,
            IdEstado: 0,
            EsElectronico: false,
            PathCertificado: '',
            CUIT: '',
            Terminal: '',
            Fiscal_RazonSocial: '',
            Fiscal_Domicilio: '',
            Fiscal_Telefono: '',
            Fiscal_Email: '',
            Fiscal_Web: '',
            Fiscal_CondicionIVA: '',
            Fiscal_CUIT: '',
            Fiscal_IIBB: '',
            Fiscal_TipoIIBB: '',
            Fiscal_InicioActividadAFIP: '',
            Fiscal_InicioActividadIIBB: '',
            CodigoListaPrecios: '',
            CodigoUbicacionPredeterminada: '',
            ImpresoraFiscalTipo: '',
            ImpresoraFiscalPuerto: '',
            ImpresoraComandera1: '',
            ImpresoraComandera2: '',
            ImpresoraComandera3: '',
            ImpresoraComanderaTicket: '',
            ImpresoraStandard: '',
            ImpresoraFiscalIP: '',
            ImpresoraComanderaRetiro: '',
            ColumnasImpresoraComanderaTicket: '',
            ImpresoraComandera4: '',
            CAIImprime: '',
            CAI: '',
            CAIComprobanteDesde: '',
            CAIComprobanteHasta: '',
            CAIFechaVencimiento: ''
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_IMP_PuntosFiscales_Leer(props.Codigo.Codigo, props.Codigo.IdTipoMovimiento, props.Codigo.IdTipo)
          
          setDatos(datosDocumento.data[0])

          if (datosDocumento.data[0]?.Logo) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

            const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
            setImagenLogoPreview(logoUrl);
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={2}>
          <GroupItem>
            <SimpleItem dataField="CodigoPuntoFiscal" editorType="dxNumberBox" >
              <Label text="Código Punto Fiscal" />
              <RequiredRule message="Indicar el Código es obligatorio." />
            </SimpleItem>

            <SimpleItem dataField="IdTipoMovimiento" editorType="dxNumberBox" >
              <Label text="Código Tipo de Movimiento" />
              <RequiredRule message="Indicar el Tipo de Movimiento es obligatorio." />
            </SimpleItem>

            <SimpleItem dataField="IdTipo" editorType="dxNumberBox" >
              <Label text="Código Tipo" />
              <RequiredRule message="Indicar el Tipo es obligatorio." />
            </SimpleItem>

            <SimpleItem>
              <Label text="Cargar Logo" />
              <input type="file" accept="image/*" onChange={handleImagenLogoChange} />
            </SimpleItem>

            {imagenLogoPreview && (
              <SimpleItem>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
                  <img
                    src={imagenLogoPreview}
                    alt="Vista Previa"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "150px",
                      objectFit: "contain",
                    }}
                  />
                  <LVButtonAccion Texto={"GUARDAR LOGO"} onClick={handleOnClick_GuardarImagenLogo} />
                </div>
              </SimpleItem>
            )}

          </GroupItem>

          <GroupItem>

            <SimpleItem dataField="Terminal" editorType="dxNumberBox" >
              <Label text="Terminal" />
            </SimpleItem>

            <SimpleItem dataField="CodigoListaPrecios" >
              <Label text="Código Lista de Precios" />
            </SimpleItem>

            <SimpleItem dataField="CodigoUbicacionPredeterminada" >
              <Label text="Código Ubicación Predeterminada" />
            </SimpleItem>

          </GroupItem>
        </Tab>

        <Tab title="Fiscal" colCount={2}>
          <GroupItem caption="Factura Electrónica">

            <SimpleItem dataField="EsElectronico" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    EsElectronico: e.value
                  }));
                }
              }}>
              <Label text="Es Electrónico" />
            </SimpleItem>
            <SimpleItem dataField="PathCertificado">
              <Label text="Path Certificado" />
            </SimpleItem>
            <SimpleItem dataField="CUIT" >
              <Label text="C.U.I.T." />
            </SimpleItem>
            <SimpleItem dataField="UltimoNumero" >
              <Label text="Último Numero" />
            </SimpleItem>

          </GroupItem>

          <GroupItem>

            <SimpleItem dataField="Fiscal_RazonSocial" >
              <Label text="Razón Social" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_Domicilio">
              <Label text="Domicilio" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_Telefono" >
              <Label text="Teléfono" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_Email">
              <Label text="E-Mail" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_Web" >
              <Label text="WEB" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_CondicionIVA">
              <Label text="Condición I.V.A." />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_CUIT" >
              <Label text="C.U.I.T." />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_IIBB">
              <Label text="I.I.B.B." />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_TipoIIBB" >
              <Label text="Tipo I.I.B.B." />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_InicioActividadAFIP">
              <Label text="Inicio de Actividad ARCA" />
            </SimpleItem>
            <SimpleItem dataField="Fiscal_InicioActividadIIBB" >
              <Label text="Inicio de Actividad I.I.B.B." />
            </SimpleItem>

          </GroupItem>

        </Tab>

        <Tab title="C.A.I." colCount={1}>

          <GroupItem>

            <SimpleItem dataField="CAIImprime" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    CAIImprime: e.value
                  }));
                }
              }}>
              <Label text="Imprime" />
            </SimpleItem>

            <SimpleItem dataField="CAI">
              <Label text="C.A.I." />
            </SimpleItem>
            <SimpleItem dataField="CAIComprobanteDesde" editorType="dxNumberBox" >
              <Label text="Comprobante Desde" />
            </SimpleItem>
            <SimpleItem dataField="CAIComprobanteHasta" editorType="dxNumberBox" >
              <Label text="Comprobante Hasta" />
            </SimpleItem>
            <SimpleItem dataField="CAIFechaVencimiento" editorType="dxDateBox" >
              <Label text="Fecha Vencimiento" />
            </SimpleItem>
          </GroupItem>

        </Tab>

        <Tab title="Impresoras" colCount={1}>

          <GroupItem colSpan={2}>
            <SimpleItem dataField="ImpresoraFiscalTipo" >
              <Label text="Fiscal Tipo" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraFiscalPuerto" >
              <Label text="Fiscal Puerto" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComandera1" >
              <Label text="Comandera 1" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComandera2" >
              <Label text="Comandera 2" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComandera3" >
              <Label text="Comandera 3" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComandera4" >
              <Label text="Comandera 4" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComanderaTicket" >
              <Label text="Comandera Ticket" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraStandard" >
              <Label text="Impresora Standard" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraFiscalIP" >
              <Label text="Impresora Fiscal IP" />
            </SimpleItem>
            <SimpleItem dataField="ImpresoraComanderaRetiro" >
              <Label text="Impresora Comandera Retiro" />
            </SimpleItem>
            <SimpleItem dataField="ColumnasImpresoraComanderaTicket" >
              <Label text="Columnas de Impresora Comandera Ticket" />
            </SimpleItem>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center" colSpan={3}>
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_IMP_PuntosFiscales;